import React from 'react';
import PropTypes from 'prop-types';
import { useBalanceSheetPageURL } from 'Hooks/useBalanceSheetPageURL';
import { useNavContext } from 'Context/NavContext';
import { useDashboardPath } from '../useDashboardPath';
import { Action } from './Action';
import { Messages } from './Messages';

export const ClientNavCPC = ({ onClick }) => {
  const { dashboardPath, dashboardSelectedIf } = useDashboardPath();
  const { pageCollectionType } = useNavContext();
  const balanceSheetPageURL = useBalanceSheetPageURL();
  // BE CAREFUL ADJUSTING THIS FILE!
  // EVEN THE SLIGHTEST ADJUSTMENT CAN CAUSE THE UI TO LOOK BAD AT THE WIDTH OF MOBILE DEVICES
  return (
    <>
      <Action value="dashboard" label="Dashboard" icon="navDashboard" to={dashboardPath} selectedIf={dashboardSelectedIf} onClick={onClick} />
      <Action
        value="accounts"
        label="Accounts"
        icon="navInvestments"
        to={balanceSheetPageURL}
        selectedIf={() => pageCollectionType === 'HouseholdBalanceSheetPX'}
        onClick={onClick}
      />
      <Messages onClick={onClick} />
    </>
  );
};

ClientNavCPC.defaultProps = {
  onClick: undefined,
};
ClientNavCPC.propTypes = {
  onClick: PropTypes.func,
};
